import React from "react"

import AccordionSummary from "@material-ui/core/AccordionSummary"

import ExpandMoreIcon from "@material-ui/icons/ExpandMore"

import useStyles from "./styles"
import getTextFromNode from "../../../../helpers/getTextFromNode"
import { DLClickEventExtended } from "../../../../helpers/WatcherDL/DLEvents"

const Question = (props: any) => {
  const classes = useStyles(props)
  const { children, withDataLayer, eventAction = "" } = props

  const handleClick = () => {
    if (withDataLayer) {
      DLClickEventExtended({
        name: getTextFromNode(children).slice(0, 30),
        placement: "switcher_content",
        eventAction,
      })
    }
  }

  return (
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls="panel1a-content"
      onClick={handleClick}
      classes={{
        root: classes.root,
        content: classes.content,
        expanded: classes.expanded,
        expandIcon: classes.expandIcon,
      }}
    >
      <div className={classes.text}>{children}</div>
    </AccordionSummary>
  )
}

export default Question
